import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "absolute left-0 w-full tw bg-white print:overflow-hidden",
  "data-cy": "clients-page"
}
const _hoisted_2 = { class: "container tw color-unset lineheight-unset flex flex-col" }
const _hoisted_3 = { class: "flex h-full w-full" }
const _hoisted_4 = {
  key: 0,
  class: "px-4 pb-4 w-full"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-8 w-full text-lg text-center font-semibold text-gray-800"
}

import { onMounted, ref } from 'vue';
import type { PropType } from 'vue';
import { storeToRefs } from 'pinia';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { useMeStore } from '@/services/UserService/useMeStore';
import type { UiRouterState } from '@/services/RouteService/UiRouterState';
import ClientsTable from './components/ClientsTable.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientsPage',
  props: {
  state: { type: Object as PropType<UiRouterState>, required: false },
},
  setup(__props) {

const props = __props;

const { handleError } = useSnackbarHandler();
const meStore = useMeStore();
const { permissions, features } = storeToRefs(meStore);
const meLoaded = ref(false);

onMounted(async () => {
  try {
    await meStore.getMe();
  } catch (error) {
    handleError(error);
    return;
  }

  // clients2 is the flag-gated list; without the flag, send the user to the same
  // state under the legacy clients root - the two route trees are identical, so a
  // create-client modal opened here survives the redirect.
  if (!features.value?.fizzyLiftingDrink) {
    const current = props.state?.current?.name || 'clients2';
    props.state?.go(current.replace(/^clients2/, 'clients'), props.state?.params);
    return;
  }

  meLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (meLoaded.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(permissions)?.matters?.create)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(ClientsTable, { state: __props.state }, null, 8, ["state"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, " You do not have permission to view this page! "))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})